import { render, staticRenderFns } from "./ServiceTable.vue?vue&type=template&id=79659c84&scoped=true&"
import script from "./ServiceTable.vue?vue&type=script&lang=ts&"
export * from "./ServiceTable.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceTable.vue?vue&type=style&index=0&id=79659c84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79659c84",
  null
  
)

export default component.exports